module.exports = __webpack_public_path__ + "static/media/About-Us-Banner-01.1561ded9.jpg";